import $ from "jquery";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { BiCreditCard, BiInfoCircle } from "react-icons/bi";
import { Link, useNavigate } from "react-router-dom";
import CommonAsyncSelect from "../../components/CommonAsyncSelect";
import Swal from "sweetalert2";
import Breadcrumb from "../../components/Breadcrumb";
import Header from "../../components/partials/Header";
import Sidebar from "../../components/partials/Sidebar";
import PayDtlCard from "../../components/PayDtlCard";
import TruncatedTextWithTooltip from "../../components/TruncatedTextWithTooltip";
import config from "../../config";
import addIcon from "../../images/icons/add.png";
import deleteIcon from "../../images/icons/delete.png";
import {
  inputfiveDigitDeciaml,
  inputTenDigitDecimal,
  inputOnlyNumber,
  millionComma,
  playBarcodeSound,
  removeMillionComma,
  userBackDate,
} from "../../utils";
import purchaseSchema from "../../validations/purchaseSchema";
import { uomConversion, uomConversionUnit } from "../Sale/util";
import "./style.css";
import { Modal } from "react-bootstrap";
import ItemViews from "../Master/Item/view";
import Tippy from "@tippyjs/react";
import { ConfigContext } from "../../App";
import { useContext } from "react";

function PurchaseAdd(props) {
  const navigate = useNavigate();
  const [godown, setGodown] = useState([]);
  const [defaultGodown, setDefaultGodown] = useState("");
  const [defaultBuyer, setDefaultBuyer] = useState("");
  const [showItemModal, setShowItemModal] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const handleItemView = (data) => {
    setSelectedItemId(data);
    setShowItemModal(true);
  };
  const isPurchaseVoucherNo = useContext(ConfigContext)?.isPurchaseVoucherNo;
  const itemLevelNarration = useContext(ConfigContext)?.itemLevelNarration;
  const handleItemModalClose = () => {
    setShowItemModal(false);
    setSelectedItemId(null);
  };

  useEffect(
    function () {
      setGodown(() => props.godown);
    },
    [props],
  );

  const itemDtl = {
    item_id: "",
    item_name: "",
    po_qty: "",
    rate: "",
    amount: "",
    godown_id: defaultGodown,
    alt_conv: "",
    base_uom: "",
    alt_uom: "",
    uom: "",
    alt_qty: "",
    alt_price: "",
    alt_rate: "",
    base_rate: "",
    narration: "",
  };

  const payDtl = [
    { mode: "Cash UGX", conv: 1, conv_amt: "", amt: "" },
    { mode: "USD", conv: 1, conv_amt: "", amt: "" },
    { mode: "Momo Pay", conv: 1, conv_amt: "", amt: "" },
    { mode: "Airtel Money", conv: 1, conv_amt: "", amt: "" },
  ];

  const initialState = {
    branch_id: "",
    buyer_id: "",
    po_no: "",
    inv_no: "",
    po_date: moment().format("YYYY-MM-DD"),
    item_dtl: [itemDtl],
    pay_dtl: payDtl,
    vehicle_no: "",
    narration: "",
    is_zero_value: "0",
    payment_mode_id: 2,
    purchase_type: config.purchaseType[0].value,
    invoice_date: moment().format("YYYY-MM-DD"),
    voucher_no: "",
    voucher_id: "",
    round_off: 0,
  };

  const [formInputs, setFormInputs] = useState(initialState);
  const [selectedBuyer, setSelectedBuyer] = useState("");
  const [selectedProduct, setSelectedProduct] = useState([]);

  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const [barcode, setBarcode] = useState("");
  const [barcodeLoading, setBarcodeLoading] = useState(false);
  const [highlightedRow, setHighlightedRow] = useState(null);
  const barcodeRef = useRef();
  const multiPurchaseVoucher = useContext(ConfigContext)?.multiPurchaseVoucher;
  const [voucherList, setVoucherList] = useState([]);

  const totalRef = useRef(0);
  const [totalValue, setTotalValue] = useState("");

  const defaultGodownRef = useRef("");
  const godownRef = useRef([]);

  useEffect(() => {
    defaultGodownRef.current = defaultGodown;
    godownRef.current = godown;
  }, [defaultGodown, godown]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (totalRef.current) {
        setTotalValue(totalRef.current.value);
      }
    }, 100);

    return () => clearInterval(interval); // Cleanup
  }, []);

  console.log("totalReftotalReftotalRef", totalRef.current.value);
  const focus = useRef([{}]);

  // Get and Set Default Supplier
  useEffect(() => {
    let branch_id =
      JSON.parse(localStorage.getItem("inventory")).userData.branch_data[0]
        .branch_id || null;
    $.post(
      `${config.apiUrl}/buyer/listBuyer`,
      JSON.stringify({ is_active: 1, is_default: branch_id }),
      (res) => {
        if (res?.data?.list?.[0]) {
          setDefaultBuyer(res.data.list[0]);
          setSelectedBuyer(res.data.list[0]);
          setFormInputs((prevState) => ({
            ...prevState,
            buyer_id: res.data.list[0]?.buyer_id,
          }));
        }
      },
    );
  }, []);

  useEffect(() => {
    if (localStorage.getItem("inventory") && multiPurchaseVoucher == 1) {
      $.post(
        `${config.apiUrl}/voucher/listVoucher`,
        JSON.stringify({
          paginate: 0,
          is_active: 1,
          module_name: "purchase",
        }),
        function (res) {
          setVoucherList(res?.data?.list || []);
        },
      );
    }
  }, [multiPurchaseVoucher]);

  function calculateTotal() {
    totalRef.current.value = 0;
    formInputs.item_dtl.forEach((item) => {
      totalRef.current.value = removeMillionComma(totalRef.current.value);
      let total = isNaN(parseFloat(totalRef.current.value))
        ? 0
        : parseFloat(totalRef.current.value);
      let total_amt = isNaN(parseFloat(item.amount))
        ? 0
        : parseFloat(item.amount);
      let amt = parseFloat(total + total_amt).toFixed(2);
      totalRef.current.value = millionComma(amt);
    });

    setSelectedProduct((prevState) => {
      return formInputs.item_dtl;
    });
  }

  function handleInputs(e) {
    setFormInputs((prevState) => {
      let newState = {
        ...prevState,
        [e.target.name]: e.target.value,
      };
      return newState;
    });
  }

  function handleTableInputs(e, rowIndex) {
    let idx =
      rowIndex !== undefined
        ? rowIndex
        : window.event?.target?.closest("tr")?.getAttribute("data-id") ||
          window.event?.srcElement?.closest("tr")?.getAttribute("data-id");

    setHighlightedRow(Number(idx));

    let product = formInputs.item_dtl[idx];
    if (e.target.name == "item_id") {
      product = e.target.value;
      delete product.godown_id;
    }

    let rate =
      e.target.name == "rate"
        ? e.target.value
        : product?.rate || product?.item_price || 0;
    let narration =
      e.target.name == "narration" ? e.target.value : product?.narration || "";
    let base_rate = product?.base_rate || rate;
    let alt_rate = product?.alt_rate || product?.alt_price || 0;

    let alt_price =
      e.target.name == "alt_price"
        ? e.target.value
        : product?.alt_price || product?.alt_price || 0;

    let qty = e.target.name == "po_qty" ? e.target.value : product.po_qty || 1;

    // let godown_id =
    //   e.target.name == "godown_id" ? e.target.value : defaultGodown;

    let currentGodownList = godownRef.current.map((x) => Number(x.godown_id));

    let godown_id = defaultGodownRef.current;

    if (e.target.name === "godown_id" || product?.item_id) {
      const currentProductId = product?.item_id || e?.item_id;
      const usedGodowns = formInputs.item_dtl
        .filter(
          (item, index) =>
            index !== parseInt(idx) &&
            item.item_id === currentProductId &&
            item.godown_id,
        )
        .map((item) => Number(item.godown_id));

      const availableGodowns = currentGodownList.filter(
        (gid) => !usedGodowns.includes(gid),
      );

      let matchedGodown = null;
      let existingGodown = Number(product?.godown_id || product?.item_godown);

      if (existingGodown && availableGodowns.includes(existingGodown)) {
        matchedGodown = existingGodown;
      } else if (product?.item_godown_data?.length > 0) {
        let found = product.item_godown_data.find((g) =>
          availableGodowns.includes(Number(g.godown_id)),
        );
        if (found) {
          matchedGodown = Number(found.godown_id);
        }
      }

      godown_id =
        e.target.name === "godown_id"
          ? e.target.value
          : matchedGodown
            ? String(matchedGodown)
            : availableGodowns[0] || defaultGodownRef.current;
    }

    //alt uom
    console.log("godown_idgodown_id", godown_id);

    let alt_conv = product?.alt_conv;
    let base_uom = product?.base_uom || product?.item_unit;
    let alt_uom = product?.alt_uom || product?.alt_unit;
    let base_conv = parseFloat(product?.base_conv || 1);
    let uom =
      e.target.name == "uom"
        ? e.target.value
        : product.uom || product.base_uom || product?.item_unit;

    let alt_qty = product?.alt_conv || 1;

    alt_qty = parseFloat(alt_conv) / parseFloat(base_conv);

    if (e.target.name == "uom") {
      // qty = product.alt_qty;
      alt_price = alt_rate;
      rate = base_rate;
    }

    if (uom === alt_uom) {
      alt_qty = alt_conv === 1 ? base_conv : base_conv / alt_conv;
      rate = (alt_price * alt_conv).toFixed(4);
    } else if (uom === base_uom) {
      alt_price = (rate / alt_conv).toFixed(4);
    }

    const grossAmt =
      uom === base_uom
        ? parseFloat(rate * qty).toFixed(4)
        : parseFloat(alt_price * qty).toFixed(4);
    // : parseFloat(
    //   rate * (parseFloat(alt_qty) * parseFloat(qty)).toFixed(2)
    // ).toFixed(4);

    const gAmt = Number(grossAmt);

    let prodDtl = {
      item_id: product.item_id,
      item_name: product.item_name,
      narration: narration,
      po_qty: qty,
      rate: rate,
      godown_id: godown_id,
      amount: isNaN(grossAmt) ? 0 : gAmt,
      alt_conv: alt_conv,
      base_uom: base_uom,
      alt_uom: alt_uom,
      uom: uom,
      alt_price: alt_price,
      alt_rate: alt_rate,
      base_rate: base_rate,
      // alt_qty: alt_qty,
      alt_qty: (parseFloat(alt_qty) * parseFloat(qty)).toFixed(4),
    };
    console.log("prodDtl", prodDtl);
    let existProdDtl = formInputs.item_dtl;
    existProdDtl[idx] = prodDtl;
    setFormInputs((prevState) => {
      let newState = {
        ...prevState,
        item_dtl: existProdDtl,
      };
      return newState;
    });
  }

  const handleBarcodeInput = (item) => {
    setFormInputs((prev) => {
      let existItemIndex = prev.item_dtl.findIndex(
        (row) => row.item_id == item.item_id,
      );

      if (existItemIndex !== -1) {
        // Increment quantity in existing row
        setHighlightedRow(existItemIndex);
        setTimeout(() => {
          let currentQty = parseFloat(
            prev.item_dtl[existItemIndex].po_qty || 0,
          );
          handleTableInputs(
            {
              target: { name: "po_qty", value: currentQty + 1 },
            },
            existItemIndex,
          );
        }, 1);
        return prev;
      } else {
        // Add new item
        let emptyRowIndex = prev.item_dtl.findIndex((row) => !row.item_id);
        let newIdx =
          emptyRowIndex !== -1 ? emptyRowIndex : prev.item_dtl.length;

        setHighlightedRow(newIdx);

        setSelectedProduct((prevState) => {
          let newState = [...prevState];
          newState[newIdx] = item;
          return newState;
        });

        if (emptyRowIndex !== -1) {
          setTimeout(() => {
            handleTableInputs(
              {
                target: { name: "item_id", value: item },
              },
              emptyRowIndex,
            );
          }, 1);
          return prev;
        } else {
          let updatedItemDtl = [...prev.item_dtl, itemDtl];
          setTimeout(() => {
            handleTableInputs(
              {
                target: { name: "item_id", value: item },
              },
              newIdx,
            );
          }, 1);
          return { ...prev, item_dtl: updatedItemDtl };
        }
      }
    });
  };

  const scanBarcode = (e) => {
    if (e) e.preventDefault();
    if (isSubmit) return;
    if (!barcode || barcode.trim().length < 2) return;

    setBarcodeLoading(true);
    $.post(
      `${config.apiUrl}/item/listItem`,
      JSON.stringify({
        paginate: 0,
        is_active: 1,
        barcode: barcode.trim(),
      }),
      (res) => {
        setBarcodeLoading(false);
        let list = res?.data?.list || [];
        if (list.length > 0) {
          playBarcodeSound(true);
          handleBarcodeInput(list[0]);
          setBarcode("");
          setTimeout(() => {
            if (barcodeRef.current) barcodeRef.current.focus();
          }, 200);
        } else {
          playBarcodeSound(false);
          Swal.fire({
            html: "Product not available of this barcode",
            icon: "error",
            confirmButtonText: "Close",
            allowEnterKey: true,
            allowEscapeKey: true,
            didOpen: () => {
              Swal.getConfirmButton().focus();
            },
          }).then(() => {
            setBarcode("");
            setTimeout(() => {
              if (barcodeRef.current) barcodeRef.current.focus();
            }, 200);
          });
        }
      },
    );
  };

  function handleItemCount(v, i) {
    if (v == "+") {
      if (formInputs.item_dtl[formInputs.item_dtl.length - 1].item_id == "") {
        Swal.fire({ html: "Please fill proper data." });
      } else {
        let existProdDtl = formInputs.item_dtl;
        existProdDtl[formInputs.item_dtl.length] = itemDtl;
        setFormInputs({ ...formInputs, item_dtl: existProdDtl });
      }
    } else if (v == "-") {
      if (formInputs.item_dtl.length == 1) {
        Swal.fire({ html: "Can't delete last row." });
      } else {
        let existProdDtl = formInputs.item_dtl.filter((v, idx) => {
          return idx != i;
        });
        setFormInputs({ ...formInputs, item_dtl: existProdDtl });
      }
    }
  }

  console.log("forminout", formInputs.item_dtl);

  async function handleSubmit(e) {
    e.preventDefault();

    const isZeroValueYes =
      formInputs.is_zero_value === 1 || formInputs.is_zero_value === "1";

    if (isZeroValueYes) {
      const allRatesNonZero = formInputs.item_dtl.every((item) => {
        const effectivePrice =
          item?.uom === item?.alt_uom ? item?.alt_price : item?.rate;
        const priceValue = parseFloat(effectivePrice);
        return priceValue > 0;
      });
      if (allRatesNonZero) {
        const result = await Swal.fire({
          title: "Zero Value Confirmation",
          html: "Your <b>Zero Value</b> is set to <b>Yes</b> but <b>none</b> of your products have zero rate.<br><br>Do you want to create the Purchase?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes, Create Purchase",
          cancelButtonText: "No",
          allowOutsideClick: false,
        });

        if (!result.isConfirmed) {
          return;
        }
      }
    }

    let grossamtval = parseFloat(totalRef.current.value.replace(/,/g, ""));
    // if (grossamtval == 0) {
    //   if (formInputs.narration == "") {
    //     Swal.fire({ html: "Narration is Required" });
    //     return;
    //   }
    // }

    let remainingAmount = grossamtval || 0;
    formInputs?.pay_dtl?.forEach((pay) => {
      if (pay.mode !== "Cash UGX") {
        remainingAmount -= parseFloat(pay.amt || 0);
      }
    });

    // const updatedPayments = formInputs?.pay_dtl?.map((pay) => {
    //   if (pay.mode === "Cash UGX") {
    //     let amount = parseFloat(remainingAmount) < 0 ? grossamtval : parseFloat(remainingAmount)
    //     return { ...pay, amt: amount || 0, conv_amt: amount || 0 };
    //   } else {
    //     return parseFloat(remainingAmount) < 0 ? { ...pay, amt: '', conv_amt: '' } : pay
    //   }
    // });
    const updatedPayments = formInputs?.pay_dtl?.map((pay) => {
      if (pay.mode === "Cash UGX") {
        let amount = parseFloat(remainingAmount);
        return { ...pay, amt: amount || 0, conv_amt: amount || 0 };
      } else {
        return pay;
      }
    });
    setFormInputs((prevState) => ({
      ...prevState,
      pay_dtl: updatedPayments,
    }));

    if (formInputs.item_dtl.length > 1) {
      formInputs.item_dtl = formInputs.item_dtl.filter((p) => p.item_id != "");
    }
    let isInvalid = await purchaseSchema.validateAdd({
      ...formInputs,
      isPurchaseVoucherNo: isPurchaseVoucherNo,
    });
    if (isInvalid?.errors) {
      Swal.fire("", isInvalid.errors[0]);
      return;
    }
    formInputs.branch_id = JSON.parse(
      localStorage.getItem("inventory"),
    )?.userData?.branch_data?.[0]?.branch_id;
    formInputs.amount = removeMillionComma(totalRef.current.value);

    let prod = [...formInputs.item_dtl];
    for (let i = 0; i < prod.length; i++) {
      let element = {};
      element = prod[i];
      if (element.uom == element.alt_uom) {
        let newProdDtl = {
          ...element,
          po_qty: element.alt_qty,
          alt_qty: element.po_qty,
        };
        prod[i] = newProdDtl;
      }
    }
    let newFormData = {
      ...formInputs,
      item_dtl: prod,
      pay_dtl: updatedPayments,
    };

    setIsSubmit(true);
    await $.post(
      `${config.apiUrl}/purchaseOrder/createPurchaseOrder`,
      JSON.stringify(newFormData),
    )
      .done(function (res) {
        let title = res.status == 200 ? "Success" : "Error";
        Swal.fire({
          title: title,
          html: `
                        Purchase Order No : <b>${
                          res?.data?.po_no || formInputs?.po_no || "N/A"
                        }</b><br/>
                        Invoice No : <b>${formInputs?.inv_no || "N/A"}</b><br/>
                        `,
          showConfirmButton: true,
          confirmButtonText: "Create New Purchase Order",
          showCancelButton: true,
          cancelButtonText: "Back to List",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
        }).then((event) => {
          if (event.isConfirmed) {
            navigate("/purchase/add");
          } else if (event.isDismissed) {
            navigate("/purchase");
          }
        });
        totalRef.current.value = 0;
        setSelectedBuyer(() => defaultBuyer);
        setSelectedProduct(() => []);
        setDefaultGodown(() => "");
        setFormInputs(() => {
          return {
            ...initialState,
            item_dtl: [{ ...itemDtl, godown_id: "" }],
            buyer_id: defaultBuyer?.buyer_id,
          };
        });
      })
      .catch(function (err) {
        Swal.fire({
          title: "Error",
          text: err?.responseJSON?.data?.message || err?.responseJSON?.message,
          confirmButtonText: "OK",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
        });
      })
      .always(function () {
        setIsSubmit(false);
      });
  }

  useEffect(function () {
    focus.current[0].buyer_id.focus();
  }, []);

  useEffect(
    function () {
      calculateTotal();
    },
    [formInputs],
  );

  const [showPayDtl, setShowPayDtl] = useState(false);
  const handlePayDtl = () => {
    setShowPayDtl((prevState) => !prevState);
  };
  const [user, setUser] = useState("");
  const [itemList, setItemList] = useState([]);
  const [itemLoading, setItemLoading] = useState(false);

  async function getItem() {
    setItemLoading(true);
    let branch_id = user;
    if (!branch_id && localStorage.getItem("inventory")) {
      branch_id = JSON.parse(localStorage.getItem("inventory"))?.userData?.branch_data?.[0]?.branch_id;
    }

    try {
      await $.post(
        `${config.apiUrl}/item/listItem`,
        JSON.stringify({
          paginate: 0,
          is_active: 1,
          branch_id: branch_id || "",
          is_preload: 1,
        }),
        function (res) {
          setItemList(res?.data?.list || []);
        }
      );
    } catch (err) {
      console.error("Item API Error", err);
      setItemList([]);
    } finally {
      setItemLoading(false);
    }
  }

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      let branch_id = JSON.parse(localStorage.getItem("inventory")).userData.branch_data[0].branch_id;
      setUser(branch_id);
    }
  }, []);

  useEffect(() => {
    if (user) {
      getItem();
    }
  }, [user]);

  function getPaymentMode() {
    const paymentModes = formInputs.pay_dtl.filter(
      (pay) => pay.amt !== "" && pay.amt !== undefined && pay.amt > 0,
    );

    if (paymentModes.length === 0) {
      return "Cash UGX";
    } else if (paymentModes.length === 1) {
      return paymentModes[0].mode;
    } else {
      return "Multiple";
    }
  }

  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div className="content m-1 p-2 position-relative pb-8">
          <Header />
          <Breadcrumb path={["Purchase", "Add Purchase"]} />

          <main className="bg-white rounded-2" id="purchaseAdd">
            <div className="container-fluid p-2 position-relative">
              <Link
                to="/purchase"
                className="position-absolute text-decoration-none small"
                style={{ top: "-1.5rem", right: "0" }}
              >
                Go Back to List
              </Link>
              <form autoComplete="off">
                <div className="row gx-3 mb-2">
                  <div className="col-md-3">
                    <label htmlFor="buyer_id">
                      Supplier Name
                      <span className="text-danger">*</span>
                    </label>
                    <CommonAsyncSelect
                      ref={(el) => (focus.current[0].buyer_id = el)}
                      noOptionsMessage={() => null}
                      placeholder="Enter atleast 3 character"
                      getOptionLabel={(o) => o.buyer_name}
                      getOptionValue={(o) => o.buyer_id}
                      loadOptions={async (inputValue, callback) => {
                        if (inputValue.toString().length > 2) {
                          await $.post(
                            `${config.apiUrl}/buyer/listBuyer`,
                            JSON.stringify({
                              paginate: 0,
                              is_active: 1,
                              buyer_name: inputValue,
                            }),
                            function (res) {
                              callback(res?.data?.list || []);
                            },
                          );
                        } else {
                          callback([]);
                        }
                      }}
                      value={selectedBuyer}
                      onChange={(e) => {
                        setSelectedBuyer(e);
                        setFormInputs((prevState) => {
                          let newState = {
                            ...prevState,
                            buyer_id: e.buyer_id,
                          };
                          return newState;
                        });
                        focus.current[0].inv_no.focus();
                      }}
                      components={{
                        IndicatorsContainer: () => null,
                      }}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          minHeight: "0px",
                          height: "29px",
                        }),
                        valueContainer: (baseStyles, state) => ({
                          ...baseStyles,
                          paddingTop: "0px",
                          paddingBottom: "0px",
                          minHeight: "0px",
                          height: "29px",
                        }),
                        input: (baseStyles, state) => ({
                          ...baseStyles,
                          paddingTop: "0px",
                          paddingBottom: "0px",
                          marginTop: "0px",
                          marginBottom: "0px",
                          minHeight: "0px",
                          height: "29px",
                        }),
                        dropdownIndicator: (baseStyles, state) => ({
                          ...baseStyles,
                          paddingTop: "0px",
                          paddingBottom: "0px",
                        }),
                        option: (baseStyles, state) => ({
                          ...baseStyles,
                          paddingTop: "0px",
                          paddingBottom: "0px",
                        }),
                      }}
                      classNamePrefix="react-select"
                      tabSelectsValue
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="inv_no">
                      Invoice No <span className="text-danger">*</span>
                    </label>
                    <input
                      ref={(el) => (focus.current[0].inv_no = el)}
                      type="text"
                      className="form-control"
                      name="inv_no"
                      value={formInputs.inv_no}
                      onKeyDown={(e) => {
                        if (e.keyCode == 32) e.preventDefault();
                      }}
                      onChange={handleInputs}
                      maxLength={50}
                    />
                  </div>
                  {multiPurchaseVoucher == 1 ? (
                    <div className="col-md-3">
                      <label htmlFor="voucher_id">Voucher Type</label>
                      <select
                        className="form-select"
                        value={formInputs.voucher_id}
                        name="voucher_id"
                        onChange={(e) => {
                          handleInputs(e);
                        }}
                      >
                        <option value="" hidden>
                          Select...
                        </option>
                        {voucherList &&
                          voucherList?.map((list) => (
                            <option key={list.voucher_id} value={list.voucher_id}>
                              {`${list.voucher_name}${
                                list.voucher_series || list.current_value
                                  ? ` (${list.voucher_series || ""}${list.current_value ?? ""})`
                                  : ""
                              }${
                                list.purchase_ledger || list.sales_ledger
                                  ? ` - ${list.purchase_ledger || list.sales_ledger}`
                                  : ""
                              }`}
                            </option>
                          ))}
                      </select>
                    </div>
                  ) : null}
                  <div className="col-md-3">
                    <label htmlFor="vehicle_no">Vehicle No</label>
                    <input
                      ref={(el) => (focus.current[0].vehicle_no = el)}
                      type="text"
                      className="form-control"
                      name="vehicle_no"
                      value={formInputs.vehicle_no}
                      // onKeyDown={(e) => {
                      //   if (e.keyCode == 32) e.preventDefault();
                      // }}
                      onChange={handleInputs}
                      maxLength={20}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="purchase_type">
                      Purchase Type <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      name="purchase_type"
                      value={formInputs.purchase_type}
                      onChange={handleInputs}
                    >
                      {config.purchaseType.map((type) => (
                        <option key={type.value} value={type.value}>
                          {type.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="invoice_date">Invoice Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="invoice_date"
                      max={moment().format("YYYY-MM-DD")}
                      value={formInputs.invoice_date}
                      onChange={handleInputs}
                    />
                  </div>
                  {/* {isPurchaseVoucherNo == 1 && ( */}
                  <div className="col-md-3">
                    <label htmlFor="voucher_no">
                      Voucher No{" "}
                      {isPurchaseVoucherNo == 1 && (
                        <span className="text-danger">*</span>
                      )}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="voucher_no"
                      value={formInputs.voucher_no}
                      onChange={handleInputs}
                      maxLength={50}
                    />
                  </div>
                  {/* )} */}
                  <div className="col-md-3">
                    <label htmlFor="narration">Narration</label>
                    <textarea
                      ref={(el) => (focus.current[0].narration = el)}
                      type="text"
                      className="form-control"
                      name="narration"
                      value={formInputs.narration}
                      // onKeyDown={(e) => {
                      //   if (e.keyCode == 32) e.preventDefault();
                      // }}
                      onChange={handleInputs}
                      maxLength={500}
                      row={3}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="default_godown">Default Godown</label>
                    <select
                      className="form-select"
                      value={defaultGodown}
                      onChange={(e) => {
                        setDefaultGodown(e.target.value);
                        // setFormInputs((prevState) => {
                        //   let newState = { ...prevState };
                        //   let itemDtl = [...newState.item_dtl];
                        //   itemDtl = itemDtl.map((item) => {
                        //     return { ...item, godown_id: e.target.value };
                        //   });
                        //   return {
                        //     ...newState,
                        //     item_dtl: itemDtl,
                        //   };
                        // });
                      }}
                    >
                      <option value="" hidden>
                        Select...
                      </option>
                      {godown &&
                        godown.map((list) => (
                          <option
                            value={list.godown_id}
                            selected={list.godown_id === defaultGodown}
                          >
                            {list.godown_name}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="po_date">
                      Purchase Date <span className="text-danger">*</span>
                    </label>
                    <input
                      // min={moment().subtract(30, "days").format("YYYY-MM-DD")}
                      min={userBackDate()}
                      max={moment().format("YYYY-MM-DD")}
                      //  min={formInputs.po_date}
                      ref={(el) => (focus.current[0].po_date = el)}
                      type="date"
                      className="form-control"
                      name="po_date"
                      value={formInputs.po_date}
                      onChange={(e) => {
                        handleInputs(e);
                      }}
                      onKeyDown={(e) => {
                        if (e.key == "Tab") {
                          return;
                        } else {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="payment_mode_id">Payment Mode</label>
                    <select
                      ref={(el) => (focus.current[0].payment_mode_id = el)}
                      className="form-select"
                      name="payment_mode_id"
                      value={formInputs.payment_mode_id}
                      onChange={(e) => {
                        const newPaymentMode = e.target.value;
                        setFormInputs((prevState) => {
                          let newState = {
                            ...prevState,
                            payment_mode_id: newPaymentMode,
                          };

                          if (newPaymentMode === "2") {
                            newState.is_zero_value = "0";
                          } else {
                            newState.is_zero_value = "0";
                          }

                          return newState;
                        });
                      }}
                    >
                      {config.paymentMode &&
                        config.paymentMode.map((list) => (
                          <option value={list.value}>{list.label}</option>
                        ))}
                    </select>
                  </div>
                  {formInputs.payment_mode_id == "2" && (
                    <div className="col-md-3">
                      <label htmlFor="is_zero_value">Zero Valued</label>
                      <select
                        name="is_zero_value"
                        value={formInputs.is_zero_value}
                        onChange={handleInputs}
                        className="form-select"
                      >
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </select>
                    </div>
                  )}
                </div>
                <div className="row">
                  <div className="col-12 p-1">
                    <table
                      className="table mt-3 rounded"
                      cellPadding="0"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th style={{ minWidth: "250px" }}>
                            <div className="d-flex align-items-center gap-2">
                              Item Name <span className="text-danger">*</span>
                              <div className="position-relative d-flex align-items-center">
                                <input
                                  ref={barcodeRef}
                                  type="text"
                                  className="form-control form-control-sm"
                                  style={{ width: "120px" }}
                                  placeholder="Scan Barcode"
                                  value={barcode}
                                  onChange={(e) => setBarcode(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      scanBarcode(e);
                                    }
                                  }}
                                />
                                {barcodeLoading && (
                                  <div
                                    className="position-absolute end-0 me-2"
                                    style={{ zIndex: 10 }}
                                  >
                                    <span
                                      className="spinner-border spinner-border-sm text-primary"
                                      role="status"
                                      aria-hidden="true"
                                      style={{
                                        width: "0.8rem",
                                        height: "0.8rem",
                                      }}
                                    ></span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </th>
                          <th>
                            Godown <span className="text-danger">*</span>
                          </th>
                          <th>UOM</th>
                          <th>
                            Qty <span className="text-danger">*</span>
                          </th>
                          <th>
                            Rate <span className="text-danger">*</span>
                          </th>

                          <th>Amount</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formInputs.item_dtl &&
                          formInputs.item_dtl.map((v, i) => (
                            <tr
                              key={i}
                              data-id={i}
                              className={
                                highlightedRow === i ? "scan-highlight" : ""
                              }
                              onClick={() => setHighlightedRow(i)}
                            >
                              <td style={{ width: "400px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    // justifyContent: "center",
                                    alignItems: "center",
                                    gap: "1px",
                                  }}
                                >
                                  <CommonAsyncSelect
                                    ref={(el) =>
                                      (focus.current[0][`prod_id_${i}`] = el)
                                    }
                                    autoFocus={true}
                                    getOptionLabel={(o) => o.item_name}
                                    placeholder="Enter atleast 3 character"
                                    getOptionValue={(o) => o.item_id}
                                    noOptionsMessage={() => null}
                                    defaultOptions={itemList}
                                    isLoading={itemLoading}
                                    loadOptions={async (inputValue, callback) => {
                                      let currentList = itemList;
                                      if (inputValue) {
                                        const search = inputValue.toLowerCase().trim();
                                        currentList = itemList.filter((item) =>
                                          item.item_name?.toLowerCase().includes(search) ||
                                          item.barcode?.toLowerCase().includes(search) ||
                                          item.SKU?.toLowerCase().includes(search)
                                        );
                                      }
                                      const filteredList = currentList.filter((item) => {
                                        const usedCount =
                                          formInputs.item_dtl.filter(
                                            (row, idx) =>
                                              idx !== i &&
                                              row.item_id ===
                                                item.item_id &&
                                              row.godown_id,
                                          ).length;
                                        return (
                                          usedCount < godown.length
                                        );
                                      });
                                      callback(filteredList);
                                    }}
                                    // filterOption={(candidate, input) => {
                                    //   if (
                                    //     selectedProduct.find(
                                    //       (p) => p.item_id === candidate.value,
                                    //     )
                                    //   )
                                    //     return false;
                                    //   else return true;
                                    // }}
                                    value={
                                      selectedProduct.find(
                                        (p) =>
                                          p.item_id ==
                                          formInputs.item_dtl[i].item_id,
                                      ) || null
                                    }
                                    onChange={async (e) => {
                                      if (e?.item_id) {
                                        await $.post(
                                          `${config.apiUrl}/item/listItem`,
                                          JSON.stringify({
                                            paginate: 0,
                                            is_active: 1,
                                            item_id: e.item_id,
                                          }),
                                          (res) => {
                                            const fullItem = res?.data?.list?.[0] || e;
                                            setSelectedProduct((prevState) => {
                                              let newState = [...prevState];
                                              newState[i] = fullItem;
                                              return newState;
                                            });
                                            handleTableInputs({
                                              target: {
                                                name: "item_id",
                                                value: fullItem,
                                              },
                                            }, i);
                                            if (
                                              itemLevelNarration === 1 &&
                                              focus.current[`narration${i}`]
                                            ) {
                                              setTimeout(
                                                () =>
                                                  focus.current[
                                                    `narration${i}`
                                                  ].focus(),
                                                0,
                                              );
                                            }
                                            focus.current[0][
                                              `godown_id_${i}`
                                            ].focus();
                                          }
                                        );
                                      }
                                    }}
                                    components={{
                                      IndicatorsContainer: () => null,
                                    }}
                                    styles={{
                                      control: (baseStyles) => ({
                                        ...baseStyles,
                                        minHeight: "0px",
                                      }),
                                      valueContainer: (baseStyles) => ({
                                        ...baseStyles,
                                        paddingTop: "0px",
                                        paddingBottom: "0px",
                                        width: "400px",
                                      }),
                                      input: (baseStyles) => ({
                                        ...baseStyles,
                                        paddingTop: "0px",
                                        paddingBottom: "0px",
                                        marginTop: "0px",
                                        marginBottom: "0px",
                                        gridTemplateColumns: "0 100%",
                                      }),
                                      dropdownIndicator: (baseStyles) => ({
                                        ...baseStyles,
                                        paddingTop: "0px",
                                        paddingBottom: "0px",
                                      }),
                                      option: (baseStyles) => ({
                                        ...baseStyles,
                                        paddingTop: "0px",
                                        paddingBottom: "0px",
                                      }),
                                    }}
                                    classNamePrefix="react-select"
                                    tabSelectsValue
                                  />
                                  {formInputs.item_dtl[i]?.item_id ? (
                                    <Tippy content="View Item">
                                      <div>
                                        {" "}
                                        <span
                                          className=""
                                          style={{ cursor: "pointer" }}
                                          onClick={() => handleItemView(v)}
                                        >
                                          <BiInfoCircle size={20} />
                                        </span>
                                      </div>
                                    </Tippy>
                                  ) : null}
                                </div>
                                {itemLevelNarration == 1 ? (
                                  <textarea
                                    ref={(el) => {
                                      if (el)
                                        focus.current[`narration${i}`] = el;
                                    }}
                                    placeholder="Item Narration"
                                    className="form-control mt-1"
                                    name={"narration"}
                                    value={v?.narration}
                                    maxLength={100}
                                    disabled={!formInputs.item_dtl[i]?.item_id}
                                    onChange={handleTableInputs}
                                    rows={2}
                                  />
                                ) : null}
                              </td>
                              <td width="170px">
                                <select
                                  ref={(el) =>
                                    (focus.current[0][`godown_id_${i}`] = el)
                                  }
                                  disabled={!formInputs.item_dtl[i]?.item_id}
                                  className="form-select"
                                  name="godown_id"
                                  value={v.godown_id}
                                  onChange={handleTableInputs}
                                >
                                  <option value="" hidden>
                                    Select...
                                  </option>
                                  {/* {godown &&
                                    godown.map((list) => (
                                      <option value={list.godown_id}>
                                        {list.godown_name}
                                      </option>
                                    ))} */}
                                  {godown &&
                                    godown
                                      .filter((g) => {
                                        const usedGodowns = formInputs.item_dtl
                                          .filter(
                                            (item, idx) =>
                                              idx != i &&
                                              item.item_id == v.item_id &&
                                              item.godown_id,
                                          )
                                          .map((item) =>
                                            Number(item.godown_id),
                                          );

                                        return !usedGodowns.includes(
                                          g.godown_id,
                                        );
                                      })
                                      .map((list) => (
                                        <option value={list.godown_id}>
                                          {list.godown_name}
                                        </option>
                                      ))}
                                </select>
                              </td>
                              <td style={{ width: "100px" }}>
                                {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <select
                                    id=""
                                    name="uom"
                                    value={v?.uom}
                                    onChange={handleTableInputs}
                                    className="form-select "
                                    // disabled={v.base_uom == v.alt_uom}
                                  >
                                    {[v.base_uom, v.alt_uom].map((ele, ind) => (
                                      <option value={ele}>{ele}</option>
                                    ))}
                                  </select>
                                )}
                              </td>

                              <td style={{ width: "100px" }}>
                                <input
                                  style={{ width: "100px" }}
                                  ref={(el) =>
                                    (focus.current[0][`po_qty_${i}`] = el)
                                  }
                                  type="text"
                                  className="form-control text-end"
                                  name="po_qty"
                                  value={v.po_qty}
                                  disabled={!formInputs.item_dtl[i]?.item_id}
                                  // maxLength={6}
                                  onChange={handleTableInputs}
                                  onKeyDown={(e) => {
                                    if (e.key == "Enter") {
                                      e.preventDefault();
                                      handleItemCount("+", i);
                                    } else {
                                      inputfiveDigitDeciaml(e);
                                    }
                                  }}
                                  required
                                  onFocus={(e) =>
                                    setTimeout(() => {
                                      e.target.select();
                                    }, 50)
                                  }
                                />
                                {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <span
                                    className="text-right"
                                    style={{
                                      wordBreak: "break-all",
                                      fontSize: "10px",
                                    }}
                                  >
                                    {/* {uomConversionUnit(v)} */}
                                    <TruncatedTextWithTooltip
                                      text={uomConversionUnit(v)}
                                    />
                                  </span>
                                )}
                              </td>
                              <td style={{ width: "130px", maxWidth: "130px" }}>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  name={
                                    v?.uom == v?.alt_uom ? "alt_price" : "rate"
                                  }
                                  disabled={!formInputs.item_dtl[i]?.item_id}
                                  maxLength={12}
                                  // value={v?.rate}
                                  value={
                                    v?.uom == v?.alt_uom
                                      ? v?.alt_price
                                      : v?.rate
                                  }
                                  onChange={handleTableInputs}
                                  onKeyDown={(e) => {
                                    if (e.key == "Enter") {
                                      e.preventDefault();
                                      handleItemCount("+", i);
                                    } else {
                                      inputOnlyNumber(e);
                                    }
                                  }}
                                  required
                                  onFocus={(e) =>
                                    setTimeout(() => {
                                      e.target.select();
                                    }, 50)
                                  }
                                />
                                {v?.alt_uom != null &&
                                  v?.alt_uom !== "" &&
                                  (v?.uom == v?.alt_uom ? (
                                    <span
                                      style={{
                                        wordBreak: "break-all",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {`( ${v?.rate} Per `}
                                      <TruncatedTextWithTooltip
                                        text={uomConversion(v)}
                                      />
                                      {`)`}
                                    </span>
                                  ) : (
                                    <span
                                      style={{
                                        wordBreak: "break-all",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {`(${v?.alt_price} Per `}
                                      <TruncatedTextWithTooltip
                                        text={uomConversion(v)}
                                      />
                                      {`)`}
                                    </span>
                                  ))}
                              </td>

                              <td>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  name="amount"
                                  value={millionComma(v?.amount)}
                                  disabled
                                />
                              </td>
                              <td
                                style={{
                                  width: "80px",
                                  verticalAlign: "middle",
                                }}
                              >
                                <img
                                  src={addIcon}
                                  style={{ width: "17px", height: "17px" }}
                                  className="img-fluid m-1"
                                  alt=""
                                  onClick={() => handleItemCount("+", i)}
                                  role="button"
                                />
                                <img
                                  src={deleteIcon}
                                  className="img-fluid m-1"
                                  style={{ width: "17px", height: "17px" }}
                                  alt=""
                                  onClick={() => handleItemCount("-", i)}
                                  role="button"
                                />
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="col-12 mt-2">
                    {(error || success) && (
                      <div
                        className={`alert alert-${
                          error ? "danger" : "success"
                        } py-2 small`}
                        role="alert"
                      >
                        {error || success || ""}
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 position-absolute bottom-0 start-0 end-0">
                  <div
                    className="row rounded px-2 py-3"
                    style={{ background: "#F4F7FE" }}
                  >
                    <div className="col-md-3">
                      <label htmlFor="round_off">Round off</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        name="round_off"
                        value={formInputs.round_off}
                        onChange={handleInputs}
                        onKeyDown={inputTenDigitDecimal}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor="totalRef">Gross Total</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        id="totalRef"
                        ref={totalRef}
                        disabled
                      />
                    </div>
                    <div className="col d-flex mt-auto justify-content-end align-items-center">
                      <div
                        style={{
                          border: "1px solid gray",
                          height: "32px",
                          minWidth: "200px",
                          borderRadius: "5px",
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <b className="me-2">{getPaymentMode()} </b> :{" "}
                        {totalValue}
                      </div>
                      <button
                        onClick={handlePayDtl}
                        className="text-primary mt-1 me-4 border border-0 bg-transparent"
                      >
                        <BiCreditCard size={32} role="button" />
                      </button>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmit}
                        onClick={handleSubmit}
                      >
                        {isSubmit && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      {showPayDtl && (
        <PayDtlCard
          cardMode="add"
          showPayDtl={showPayDtl}
          handlePayDtl={handlePayDtl}
          formInputs={formInputs}
          setFormInputs={setFormInputs}
          grossTotal={removeMillionComma(totalRef.current.value)}
        />
      )}
      <Modal
        show={showItemModal}
        onHide={handleItemModalClose}
        keyboard={false}
        backdrop="static"
        size="lg"
      >
        <ItemViews id={selectedItemId} hide={handleItemModalClose} />
      </Modal>
    </>
  );
}

export default PurchaseAdd;
